import { render, staticRenderFns } from "./ComponentExample.vue?vue&type=template&id=08c50576&"
import script from "./ComponentExample.vue?vue&type=script&lang=js&"
export * from "./ComponentExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports